import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommunityRequestTypesProvider as Provider } from '../../components/context/community-request-types-context';
import { platformProviderValue } from '@shapeable/ui';

const COMMUNITY_REQUEST_TYPES_QUERY = graphql`
query PlatformAllCommunityRequestTypesQuery {
  platform { allCommunityRequestTypes {
    
      
    
        id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
      
      
            openGraph { 
              id title 
              
              image { 
                id url url2x 
                thumbnails { 
                  id bubbleMedium { id url url2x }
                }
                
              } 
            }
          
    
    description { id text }
  } }
}
`

export const CommunityRequestTypesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(COMMUNITY_REQUEST_TYPES_QUERY), 'allCommunityRequestTypes' ) }>{children}</Provider>;
};